module.exports = __webpack_public_path__ + "img/peopleVaccinated.bfc26577.png";